import { downloadBlob } from "./downloadBlob";

export const downloadBlobFromUrl = async (url: string, fileName: string): Promise<void> => {
  const response = await fetch(url);
  const blob = await response.blob();
  downloadBlob(blob, fileName);
};
